import { ArrowRight, Check, Wifi } from "lucide-react";
import cardImg from "@/assets/tecopos-card.jpg";

const benefits = [
  "Fideliza clientes con saldo recargable",
  "Crédito controlado para empleados",
  "Monederos internos sin comisiones bancarias",
  "Historial de transacciones en tiempo real",
];

export function TecoposCard() {
  return (
    <section className="relative py-24 lg:py-32 bg-foreground text-background overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(50%_40%_at_50%_30%,rgba(217,96,46,0.18),transparent_70%)]" />
      <div className="absolute inset-0 -z-10 opacity-[0.04]" style={{
        backgroundImage: "linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)",
        backgroundSize: "44px 44px",
      }} />

      <div className="max-w-7xl mx-auto px-5 lg:px-6 grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <div className="order-2 lg:order-1 relative">
          <div className="relative max-w-md mx-auto">
            <img
              src={cardImg}
              alt="Tarjeta TecoPOS"
              width={1024}
              height={1024}
              loading="lazy"
              className="w-full aspect-square object-cover rounded-[40px] animate-float"
            />
          </div>

          {/* Floating dashboard panel */}
          <div className="absolute -bottom-4 right-2 lg:-right-4 w-64 bg-white/[0.04] backdrop-blur-xl rounded-2xl border border-white/10 p-5 hidden md:block">
            <div className="flex items-center justify-between mb-4">
              <span className="text-[10px] uppercase tracking-widest text-neutral-400">Saldo disponible</span>
              <Wifi className="size-3.5 text-neutral-500" />
            </div>
            <p className="text-2xl font-bold mb-1">$2,480.00</p>
            <p className="text-[11px] text-emerald-400 mb-4">+$200 recarga hoy</p>
            <div className="space-y-2">
              <div className="flex justify-between text-[11px]">
                <span className="text-neutral-400">Café Meraki</span>
                <span>−$12.50</span>
              </div>
              <div className="flex justify-between text-[11px]">
                <span className="text-neutral-400">Recarga</span>
                <span className="text-emerald-400">+$200</span>
              </div>
              <div className="flex justify-between text-[11px]">
                <span className="text-neutral-400">Salón Lumina</span>
                <span>−$45.00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2 space-y-8 reveal">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">
            Tarjeta TecoPOS
          </span>
          <h2 className="text-4xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            Más que una tarjeta. Es tu programa de lealtad.
          </h2>
          <p className="text-neutral-400 text-lg max-w-lg">
            Emite tarjetas personalizadas con saldo para clientes y empleados. Recargas, créditos internos y analíticas de consumo integradas nativamente.
          </p>

          <ul className="space-y-3 pt-2">
            {benefits.map((b) => (
              <li key={b} className="flex items-start gap-3 text-neutral-200">
                <span className="mt-1 size-5 rounded-full bg-primary/20 text-primary grid place-items-center">
                  <Check className="size-3" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <button className="group inline-flex items-center gap-2 px-7 py-4 bg-primary text-primary-foreground font-bold rounded-xl hover:bg-primary/90 transition-all">
            Activa tu sistema de tarjetas
            <ArrowRight className="size-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
